import { SPRYKER_PRODUCT_CARD_MAIN_PATH } from '../constants';
import { ProductsApi } from '../types/api/products-api';
import { ProductCardMainRequestParams } from '../types/api-params/productCardMain';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';

export class SprykerProductCardMainHandler extends RequestHandler {
  api = {
    target: 'spryker-product-card-main',
    default: 'spryker-default',
  };

  getProductCardMain({
    productIdList,
    ...parameters
  }: ProductCardMainRequestParams): NetworkResponse<ProductsApi.GetProductsResponse> {
    return this.get<ProductsApi.GetProductsResponse>(
      UrlBuilder.buildSprykerURL({
        ...parameters,
        endPointName: SPRYKER_PRODUCT_CARD_MAIN_PATH,
        queryParams: { ids: productIdList },
      }),
    );
  }
}

export const SprykerProductCardMain = new SprykerProductCardMainHandler();
